import React, { createContext, useCallback, useContext, useRef } from "react";

export type PostType = "classPost" | "assignmentPost";
export interface CurrentPostContext {
  postUid: string;
  postType: PostType;
  postTitle: string;
}
type OpenForPostFn = (
  postUid: string,
  postType: PostType,
  postTitle: string,
) => void;

interface MessageTeacherContextValue {
  openForPost: OpenForPostFn;
  registerOpenForPost: (fn: OpenForPostFn) => void;
  currentPostContext: CurrentPostContext | null;
  setCurrentPostContext: React.Dispatch<
    React.SetStateAction<CurrentPostContext | null>
  >;
}

const MessageTeacherContext = createContext<MessageTeacherContextValue>({
  openForPost: () => {},
  registerOpenForPost: () => {},
  currentPostContext: null,
  setCurrentPostContext: () => {},
});

export function MessageTeacherProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const fnRef = useRef<OpenForPostFn>(() => {});
  const [currentPostContext, setCurrentPostContext] =
    React.useState<CurrentPostContext | null>(null);

  const registerOpenForPost = useCallback((fn: OpenForPostFn) => {
    fnRef.current = fn;
  }, []);

  const openForPost = useCallback<OpenForPostFn>(
    (postUid, postType, postTitle) => {
      fnRef.current(postUid, postType, postTitle);
    },
    [],
  );

  return (
    <MessageTeacherContext.Provider
      value={{
        openForPost,
        registerOpenForPost,
        currentPostContext,
        setCurrentPostContext,
      }}
    >
      {children}
    </MessageTeacherContext.Provider>
  );
}

export function useMessageTeacher() {
  return useContext(MessageTeacherContext);
}
